import React, { ReactNode } from "react"
import { useSelector } from "react-redux"
import { selectContent } from "../../../domain/CMS/model"
import { DynamicTable } from "../../shared/components/Table/DynamicTable"
import {
  TableCellType,
  TableHeader,
  TableRow,
} from "../../shared/components/Table/types"

export type LegacyDisclosureTableRow = {
  downloadLink: ReactNode
  uploadedBy: string
  uploadDate: string
  remove: ReactNode
}

export type DisclosureTableRow = {
  downloadLink: { node: ReactNode; value: string }
  uploadedBy: { node: ReactNode; value: string }
  uploadDate: { node: ReactNode; value: string }
  onRemoveClick?: () => void
}

interface TempTableComponentProps {
  files: DisclosureTableRow[]
}

export const DisclosureTable: React.FC<TempTableComponentProps> = ({
  files,
}) => {
  const { common: commonText } = useSelector(selectContent)

  // DynamicTable configuration
  const dynamicHeaders: TableHeader[] = [
    {
      label: commonText?.fileDownload ?? "",
      type: TableCellType.STRING,
    },
    {
      label: commonText?.uploadedBy ?? "",
      type: TableCellType.STRING,
    },
    {
      label: commonText?.uploadDate ?? "",
      type: TableCellType.STRING,
    },
  ]

  const dynamicRows: TableRow[] = files.map((file, index) => ({
    data: {
      id: `disclosure-file-row-${index}`,
      cells: [
        {
          id: `disclosure-downloadLink-${index}`,
          value: file.downloadLink.value,
          node: file.downloadLink.node,
        },
        {
          id: `disclosure-uploadedBy-${index}`,
          value: file.uploadedBy.value,
          node: file.uploadedBy.node,
        },
        {
          id: `disclosure-uploadDate-${index}`,
          value: file.uploadDate.value,
          node: file.uploadDate.node,
        },
      ],
    },
    onDeleteClick: file.onRemoveClick,
  }))

  const showDeleteColumn = dynamicRows.some((row) => !!row.onDeleteClick)

  return (
    <DynamicTable
      headers={dynamicHeaders}
      rows={dynamicRows}
      showDeleteColumn={showDeleteColumn}
    />
  )
}
